import { AccessGroup } from 'interfaces/AccessGroup';

import { RepositoryParams, api } from '..';

export type AccessGroupFilters = Partial<AccessGroup & RepositoryParams>;

export const list = async (params: AccessGroupFilters) => {
  return api.get('access_groups', { params });
};

export const create = async (params: Partial<AccessGroup>) => {
  return api.post('access_groups', { ...params });
};

export const update = async (params: Partial<AccessGroup>) => {
  return api.patch(`access_groups/${params.id}`, {
    ...params,
  });
};

export const retrieve = async (id: string) => {
  return api.get(`access_groups/${id}`);
};

export const listPermissions = async () => {
  return api.get('access_groups/permissions');
};
